import { Alert, Text, Title } from "@mantine/core";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { accountsApi } from "./api";
import { AccessManagementPanel } from "./AccessManagementPanel";
import { WorkspaceClosurePanel } from "./WorkspaceClosurePanel";
import { AccountsGate } from "./AccountsGate";
import type { ClosureView, TenantDetail } from "./types";
function Detail() {
  const { tenantPublicId = "" } = useParams(); const scope = { kind:"platform" as const, tenantPublicId }; const cache=useQueryClient();
  const query=useQuery({queryKey:["account-access",scope],retry:false,queryFn:async ():Promise<{detail:TenantDetail|null;closure:ClosureView|null}> => {
    try {const detail=await accountsApi.getTenant(tenantPublicId); return {detail,closure:detail.closure ?? null};}
    catch (error) {if ((error as {status?:number}).status !== 404) throw error; return {detail:null,closure:await accountsApi.getWorkspaceClosure(tenantPublicId)};}
  }});
  function refresh() {void cache.invalidateQueries({queryKey:["account-access"]});void cache.invalidateQueries({queryKey:["platform-tenants"]});}
  const detail=query.data?.detail; const closure=query.data?.closure ?? null;
  return <section className="hosted-content-card accounts-page accounts-tenant-detail"><Link to="/admin/companies">Toutes les entreprises</Link>
    {query.isLoading ? <Text>Chargement…</Text> : null}{query.isError ? <Alert color="red">{query.error.message}</Alert> : null}
    {query.data ? <><div><p className="hosted-kicker">Administration Relyo</p><Title order={1}>{detail?.tenant.name ?? "Fermeture d’un espace"}</Title></div>
      {detail && ["active","pending_activation"].includes(detail.tenant.status) ? <AccessManagementPanel scope={scope} access={detail} /> : null}
      <WorkspaceClosurePanel tenant={detail?.tenant} closure={closure} enabled={detail?.lifecycle_enabled} onClosed={refresh} />
    </> : null}
  </section>;
}
export function PlatformTenantPage() {return <AccountsGate platform><Detail /></AccountsGate>;}
